import { Fetch } from './FetchApi';

export const FetchConfig = async (url) => {
  //console.log('Fetch Config: ', url);
  const payload = {
    method: 'GET',
  }
  return await Fetch(url, payload);
}
